/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Groupsformhint2Inputs */

const en_groupsformhint2 = /** @type {(inputs: Groupsformhint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Members see that you run this group. You see their names and messages.`)
};

const de_groupsformhint2 = /** @type {(inputs: Groupsformhint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitglieder sehen, dass die Gruppe von dir betreut wird. Du siehst ihre Namen und Nachrichten.`)
};

/**
* | output |
* | --- |
* | "Members see that you run this group. You see their names and messages." |
*
* @param {Groupsformhint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const groupsformhint2 = /** @type {((inputs?: Groupsformhint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Groupsformhint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_groupsformhint2(inputs)
	return de_groupsformhint2(inputs)
});
export { groupsformhint2 as "groupsFormHint" }